import { render } from "./HealthCheckPage.vue?vue&type=template&id=a33c46d6&scoped=true"
import script from "./HealthCheckPage.vue?vue&type=script&lang=js"
export * from "./HealthCheckPage.vue?vue&type=script&lang=js"

import "./HealthCheckPage.vue?vue&type=style&index=0&id=a33c46d6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a33c46d6"]])

export default __exports__